export const RESTAURANT_NAME = 'Smothers Restaurant';
export const RESTAURANT_TAGLINE = 'Crafted burgers. Bold flavors. Unforgettable bites.';
export const WHATSAPP_PHONE = '254700000000'; // Replace with real number

export const NAV_LINKS = [
  { label: 'Home', to: '/', icon: 'Home' },
  { label: 'Menu', to: '/menu', icon: 'UtensilsCrossed' },
];

export const HERO_IMAGE =
  'https://images.unsplash.com/photo-1550547660-d9450f859349?auto=format&fit=crop&w=1920&q=80';

export const PLACEHOLDER_PRODUCT_IMAGE =
  'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=800&q=60';
